import { render, staticRenderFns } from "./DescriptionColumn.vue?vue&type=template&id=11a8a7a0&scoped=true&"
import script from "./DescriptionColumn.ts?vue&type=script&lang=ts&"
export * from "./DescriptionColumn.ts?vue&type=script&lang=ts&"
import style0 from "./DescriptionColumn.scss?vue&type=style&index=0&id=11a8a7a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a8a7a0",
  null
  
)

export default component.exports